
export function intOrUndefined(num: string | undefined | null): number|undefined {
  if(!num) {
    return undefined
  }

  const i = parseInt(num)
  if(isNaN(i)) {
    return undefined
  }

  return i
}